import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import AuthProvider from './AuthProvider';
import { adminRoutes, schoolAdminRoutes, userRoutes } from './routes';
import { httpGet, setHttpToken } from '../utilities/http';
import { Get_User_Url } from '../api';
import { setUser } from '../store/userSlice';
import { checkErrorBoundary, getToken } from '../utilities/utils';
import { NotFound } from '../pages/NotFound';
import ErrorBoundary from '../components/ErrorBoundary';
import { setError } from '../store/generalSlice';
import ScrollToTop from './ScrollToTop';
import FullScreenLoader from '../components/common/FullScreenLoader';
import Layout from '../components/layouts';

const Login = React.lazy(() => import('../pages/Login'));
const Signup = React.lazy(() => import('../pages/SignupPage'));
const ForgetPassword = React.lazy(() => import('../pages/ForgetPassword'));
const NewPassword = React.lazy(() => import('../pages/NewPassword'));

export default function AppRoutes() {
  const user = useSelector((state) => state.user);
  const generalStates = useSelector((state) => state.general);
  const { error } = generalStates;
  const dispatch = useDispatch();
  const token = getToken();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (token) {
      setHttpToken(token);
      getUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  function getUser() {
    setIsLoading(true);
    httpGet(Get_User_Url)
      .then((res) => {
        if (res.status === 200) {
          // eslint-disable-next-line no-param-reassign
          res = res.data;
          dispatch(
            setUser({
              ...user,
              ...res,
            })
          );
        }
      })
      .catch((err) => {
        const errorBoundary = checkErrorBoundary(err);
        dispatch(setError(errorBoundary));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <>
      {isLoading && <FullScreenLoader />}
      {error?.hasError && error?.type === 'errorBoundary' && <ErrorBoundary />}
      <ReactErrorBoundary FallbackComponent={ErrorBoundary}>
        <React.Suspense fallback={<FullScreenLoader />}>
          {!isLoading && (
            <ScrollToTop>
              <Routes>
                <Route element={<Layout />}>
                  <Route element={<Login />} exact path="/" />
                  <Route element={<Signup />} exact path="/signup/:refercode?" />
                  <Route element={<ForgetPassword />} exact path="/forgetpassword" />
                  <Route element={<NewPassword />} exact path="/reset-password" />
                  <Route element={<AuthProvider />}>
                    {userRoutes.map((route) => (
                      <Route key={route.path} {...route} />
                    ))}
                    {/* {role === USER_ROLE.ADMIN && adminRoutes.map((route) => <Route key={route.path} {...route} />)} */}
                    {adminRoutes.map((route) => (
                      <Route key={route.path} {...route} />
                    ))}
                    {/* {role === USER_ROLE.SCHOOL_ADMIN &&
                  schoolAdminRoutes.map((route) => <Route key={route.path} {...route} />)} */}
                    {schoolAdminRoutes.map((route) => (
                      <Route key={route.path} {...route} />
                    ))}
                  </Route>
                </Route>
                <Route element={<NotFound />} path="*" />
              </Routes>
            </ScrollToTop>
          )}
        </React.Suspense>
      </ReactErrorBoundary>
    </>
  );
}
